import { render } from "./ClassicalBuilding.vue?vue&type=template&id=40054b1a"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ClassicalBuilding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40054b1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40054b1a', __exports__)) {
    api.reload('40054b1a', __exports__)
  }
  
  module.hot.accept("./ClassicalBuilding.vue?vue&type=template&id=40054b1a", () => {
    api.rerender('40054b1a', render)
  })

}


export default __exports__